<template>
  <v-form ref="mainForm" v-model="valid">
    <data-iterator
      :list="sas.stagesInternats"
      add-new-text="Ajouter une formation pratique"
      :live="{ endpoint: 'sas-equivalence-stages-internats', sasId: sas.id }"
      optional
      card-width="900"
      :icon="$getIcon('formationPratique')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.typeDeFormationPratique ? getCatalogueValueById(4502, item.typeDeFormationPratique).text : "" }}</h3>
        <p class="my-0">
          {{
            item.niveauUniversitaire && !estNiveauUniversitaireAutre(item.niveauUniversitaire)
              ? getCatalogueValueById(4503, item.niveauUniversitaire).text
              : item.autreNiveau
          }}
        </p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-catalogue code="type-pratique" v-model="item.typeDeFormationPratique" :live="liveSasStagesInternats(7102, item)"></opq-catalogue>
        <opq-catalogue
          code="niveau-universitaire-pratique"
          v-model="item.niveauUniversitaire"
          :live="liveSasStagesInternats(7103, item)"
        ></opq-catalogue>
        <opq-text-field
          :opq-if="estNiveauUniversitaireAutre(item.niveauUniversitaire)"
          code="autre-niveau-pratique"
          v-model="item.autreNiveau"
          :live="liveSasStagesInternats(7104, item)"
        ></opq-text-field>
        <opq-relation
          code="selection-releve-note-pratique"
          optional
          v-model="item.releveDeNotes"
          :live="liveSasStagesInternats(7105, item)"
          :list="relevesDeNotes"
        ></opq-relation>
        <opq-memo code="infos-pratique" v-model="item.details" :live="liveSasStagesInternats(7106, item)"></opq-memo>
        <opq-catalogue code="secteur-pratique" v-model="item.secteurPratique" :live="liveSasStagesInternats(7107, item)"></opq-catalogue>
        <opq-text-field code="lieu-pratique" v-model="item.lieuPratique" :live="liveSasStagesInternats(7108, item)"></opq-text-field>
        <opq-text-field code="type-clientele-pratique" v-model="item.typeClientele" :live="liveSasStagesInternats(7109, item)"></opq-text-field>
        <opq-date-picker code="debut-pratique" v-model="item.dateDebut" :live="liveSasStagesInternats(7110, item)"></opq-date-picker>
        <opq-date-picker code="fin-pratique" v-model="item.dateFin" :live="liveSasStagesInternats(7111, item)"></opq-date-picker>
        <opq-text-field
          code="nombre-heures-pratique"
          v-model="item.nombreHeuresPratique"
          :live="liveSasStagesInternats(7112, item)"
          isNumber
        ></opq-text-field>
        <opq-memo code="superviseur-pratique" v-model="item.superviseurPratique" :live="liveSasStagesInternats(7113, item)"></opq-memo>
        <opq-memo code="format-supervision-pratique" v-model="item.formatSupervision" :live="liveSasStagesInternats(7116, item)"></opq-memo>
        <opq-text-field
          code="nombre-heures-supervision-pratique"
          v-model="item.nombreHeuresSupervision"
          :live="liveSasStagesInternats(7114, item)"
          isNumber
        ></opq-text-field>
        <opq-text-field
          code="nombre-heures-observation-pratique"
          v-model="item.nombreHeuresObservation"
          :live="liveSasStagesInternats(7115, item)"
          isNumber
        ></opq-text-field>
        <opq-text-field
          code="nombre-heures-clientele-pratique"
          v-model="item.precisezLeNombreTotalDHeuresDeContact"
          :live="liveSasStagesInternats(7117, item)"
          isNumber
        ></opq-text-field>
        <opq-catalogue
          code="orientations-theoriques-pratique"
          v-model="item.orientationsTheoriques"
          :live="liveSasStagesInternats(7118, item)"
          optional
        ></opq-catalogue>
        <opq-memo code="modalites-evaluation-pratique" v-model="item.modalitesEvaluation" :live="liveSasStagesInternats(7119, item)"></opq-memo>
        <opq-text-field
          code="nombre-heures-evaluation-pratique"
          v-model="item.nombreHeuresEvaluationPratique"
          :live="liveSasStagesInternats(7120, item)"
          isNumber
        ></opq-text-field>
        <opq-memo code="types-interventions-pratique" v-model="item.typesInterventionsPratique" :live="liveSasStagesInternats(7121, item)"></opq-memo>
        <opq-text-field
          code="nombre-heures-intervention-pratique"
          v-model="item.nombreHeureInterventionPratique"
          :live="liveSasStagesInternats(7122, item)"
          isNumber
        ></opq-text-field>
        <opq-memo code="activites-autonomie-pratique" v-model="item.activitesAutonomiePratique" :live="liveSasStagesInternats(7123, item)"></opq-memo>
        <opq-memo code="details-pratique" v-model="item.detailsPratique" :live="liveSasStagesInternats(7124, item)" optional></opq-memo>
        <opq-file-multiple code="fichiers-pratique" :files="item.fichiersPratiques" :live="liveSasStagesInternats(7125, item)"></opq-file-multiple>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },
  computed: {
    relevesDeNotes() {
      let releves = []
      this.sas.diplomes.forEach((diplome) => {
        diplome.relevesDeNotes.forEach((releve) => {
          releves.push(releve)
        })
      })
      return releves
    }
  },
  methods: {
    liveSasStagesInternats(cle, item) {
      return { endpoint: "sas-equivalence-stages-internats", cle: cle, fileId: item.id }
    },
    estNiveauUniversitaireAutre(niveau) {
      return this.getCatalogueCodeById(4503, niveau) == "autre"
    }
  }
}
</script>

<style>
</style>